import httpClient from './httpClient';

const BASE = '/api/cuentas-por-cobrar';

/**
 * Cuentas por cobrar: facturar a crédito (curso/nivel + cantidad de cupos)
 * antes de que exista matrícula o pago real. Ver memoria del proyecto:
 * project_cuentas_por_cobrar_empresas.
 */
const cuentasPorCobrarService = {

  /**
   * Emite la factura en Contífico de inmediato (a crédito, sin cobro) y
   * guarda el compromiso localmente.
   * @param {Object} data
   * @param {string}   [data.deudor_tipo="empresa"]
   * @param {number}   data.deudor_id
   * @param {Array}    data.lineas  [{curso_id, cantidad, precio_unitario?}]
   * @param {string}   [data.observaciones]
   */
  crear(data) {
    return httpClient.post(BASE, data);
  },

  /**
   * Listar cuentas por cobrar.
   * @param {Object} [filtros]
   */
  listar(filtros = {}) {
    const params = new URLSearchParams();
    if (filtros.deudor_tipo) params.set('deudor_tipo', filtros.deudor_tipo);
    if (filtros.deudor_id) params.set('deudor_id', filtros.deudor_id);
    const qs = params.toString();
    return httpClient.get(`${BASE}${qs ? `?${qs}` : ''}`);
  },

  obtenerPorId(id) {
    return httpClient.get(`${BASE}/${id}`);
  },

  /**
   * Consume cupos ya facturados aplicándolos a matrículas reales.
   * No genera una factura nueva — la factura ya existe.
   * @param {number}   id
   * @param {number[]} matricula_ids
   */
  aplicarCredito(id, matricula_ids) {
    return httpClient.post(`${BASE}/${id}/aplicar`, { matricula_ids });
  },

  /**
   * Registra el dinero que la empresa efectivamente pagó contra la
   * factura ya emitida (Fase 3) — no crea una factura nueva.
   * @param {number} id
   * @param {Object} data { monto, metodo_id, referencia_externa, fecha }
   */
  registrarCobro(id, data) {
    return httpClient.post(`${BASE}/${id}/cobro`, data);
  },
};

export default cuentasPorCobrarService;
